import { Col, Row } from 'antd'
import Button from 'components/Button'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import LinkedIn from '../../../../../../src/assets/images/LinkedInRadiusImage.png'
import FileIcon from '../../../../../components/icons/FileIcon'
import { EventStatusCard } from '../../../ListView/List/partials/Upcoming/style'
import {
  Category,
  Container1,
  EventData1,
  EventData4,
  EventDatecard,
  EventLabel,
  EventName,
  EventRegistration,
  EventRegistrationText,
  EventSection,
  LinkedInLink,
  PreviewAnswer,
  PreviewTitle,
  RegistrationText,
  ShowLessText,
  ShowMoreText,
  StyledCol,
  StyledDivision,
  StyledRow,
  Uploaders,
  Size,
} from './style'

const EventPreviewContent = ({
  data,
  handleClick,
  handleRegistrationClick,

  open
}) => {
  const [expanded, setExpanded] = useState(true)
  const [isHeight, setIsHeight] = useState(false)
  const typeLabels = {
    OTHERS: 'Others',
    PRE_PLACEMENT_TALK: 'Pre Placement Talk',
    SEMINAR: 'Seminar',
    WEBINAR: 'Webinar',
    LECTURE: 'Lecture',
    CONFERENCE: 'Conference',
    PANEL_DISCUSSION: 'Panel Discussion',
    HACKATHON: 'Hackathon',
    WORKSHOP: 'Workshop',
    CAMPAIGN: 'Campaign',
    SPORTS_EVENT: 'Sports Event',
    ACTIVITY_EVENT: 'Activity / Event',
    EXHIBITION: 'Exhibition',
  }
  const categoryStyles = {
    OTHERS: {
      borderColor: '#001B48',
      backgroundColor: 'rgba(0, 27, 72, 0.2)',
      textColor: 'White',
    },
    PRE_PLACEMENT_TALK: {
      borderColor: '#97CADB',
      backgroundColor: 'rgba(151, 202, 219, 0.2)',
      textColor: 'Black',
    },
    SEMINAR: {
      borderColor: '#B5A3F7',
      backgroundColor: 'rgba(181, 163, 247, 0.2)',
      textColor: 'Black',
    },
    WEBINAR: {
      borderColor: '#E1A7BA',
      backgroundColor: 'rgba(225, 167, 186, 0.2)',
      textColor: 'Black',
    },
    LECTURE: {
      borderColor: '#8D6AA0',
      backgroundColor: 'rgba(141, 106, 160, 0.2)',
      textColor: 'White',
    },
    CONFERENCE: {
      borderColor: '#F29F05',
      backgroundColor: 'rgba(242, 159, 5, 0.2)',
      textColor: 'Black',
    },
    PANEL_DISCUSSION: {
      borderColor: '#F25C05',
      backgroundColor: 'rgba(242, 92, 5, 0.2)',
      textColor: 'Black',
    },
    HACKATHON: {
      borderColor: '#31AAB5',
      backgroundColor: 'rgba(49, 170, 181, 0.2)',
      textColor: 'Black',
    },
    WORKSHOP: {
      borderColor: '#72B06F',
      backgroundColor: 'rgba(114, 176, 111, 0.2)',
      textColor: 'Black',
    },
    CAMPAIGN: {
      borderColor: '#4C1D91',
      backgroundColor: 'rgba(76, 29, 145, 0.2)',
      textColor: 'White',
    },
    SPORTS_EVENT: {
      borderColor: '#13593F',
      backgroundColor: 'rgba(19, 89, 63, 0.2)',
      textColor: 'White',
    },
    ACTIVITY_EVENT: {
      borderColor: '#02457A',
      backgroundColor: 'rgba(2, 69, 122, 0.2)',
      textColor: 'White',
    },
    EXHIBITION: {
      borderColor: '#595F33',
      backgroundColor: 'rgba(89, 95, 51, 0.2)',
      textColor: 'White',
    },
  }
  const categoryStyle = categoryStyles[data?.category] || {
    borderColor: '#d8ddff',
    backgroundColor: 'white',
    textColor: 'black',
  }
  const formatTime = time => {
    let timeSplit

    if (moment.isMoment(time)) {
      timeSplit = time.format('HH:mm')
    } else if (typeof time === 'string' && time?.includes(':')) {
      timeSplit = time
    } else {
      console.error('Invalid time format')
      return ''
    }
    const [hour, minute] = (timeSplit?.split(':') || ['00', '00']);

    const hourNumber = parseInt(hour, 10)
    const period = hourNumber >= 12 ? 'PM' : 'AM'
    const formattedHour = hourNumber % 12 || 12
    return `${formattedHour}:${minute} ${period}`
  }
  const formatDateTime = dateString => {
    return moment(dateString).format('DD/MM/yyyy')
  }
  const downloadFileLocal = async file => {
    try {
      const response = await fetch(file.url)
      if (!response.ok) {
        throw new Error('Failed to download file')
      }
      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = file.name
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } catch (error) {
      console.error('Error downloading file:', error)
    }
  }
  const convertBytesToKB = bytes => {
    return (bytes / 1024).toFixed(2)
  }

  const truncateName = (name, maxLength) => {
    if (name.length > maxLength) {
      return name.substring(0, maxLength) + '...'
    }
    return name
  }
  const joinSeminar = data?.studentEventMapping?.length > 0;


  const toggleExpanded = () => {
    setExpanded(!expanded)
  }
  const hasTime = data?.startTime && data?.endTime
  const contentHeight = useRef(null)

  useEffect(() => {
    const checkHeight = () => {
      if (contentHeight?.current) {
        setExpanded(true)
        const height = contentHeight.current.clientHeight;
        setIsHeight(height)
        if (height > 250) {
          // setIsHeight(true)
          setExpanded(false);
        } 
        // else if(height < 250){
        //   setIsHeight(false)
        // }
        else if (height === 0) {
          // Force re-render to re-check the height
          setTimeout(() => checkHeight(), 100);
        }
      }
    };

    checkHeight();
  }, [open])

  const degreeDataList = Object.entries(data?.eventDegreeMapping).flatMap(
    ([degreeType, degrees]) => {
      if (!Array.isArray(degrees) || degrees.length === 0) {
        return []
      }
      return degrees.map(degree => ({
        shortForm: degree.shortForm,
        streams: Array.isArray(degree.streams)
          ? degree.streams.map(stream => ({
              name: stream.name,
              specialisations: Array.isArray(stream.specialisations)
                ? stream.specialisations.map(spec => spec.name)
                : [],
            }))
          : [],
      }))
    }
  )

  const renderContent = () => {
    return (
      <EventData4>
        {data?.eventDegreeMapping && data?.eventDegreeMapping.length > 0 ? (
          data?.eventDegreeMapping.map(degree => {
            const hasDepartments = degree.streams?.length > 0
            return (
              <React.Fragment key={degree.degreeId}>
                {hasDepartments ? (
                  degree.streams.length > 0 ? (
                    degree.streams.map(dep =>
                      dep.specializations && dep.specializations.length > 0 ? (
                        dep.specializations.map(spec => (
                          <div
                            key={`${degree.degreeId}-${dep.streamId}-${spec.specialisationId}`}
                          >
                            {`${degree.shortForm} - ${dep.name} (${spec.name})`}
                          </div>
                        ))
                      ) : (
                        <div key={`${degree.degreeId}-${dep.streamId}`}>
                          {`${degree.shortForm} - ${dep.name}`}
                        </div>
                      )
                    )
                  ) : (
                    <div key={degree.degreeId}>{degree.shortForm}</div>
                  )
                ) : (
                  <div key={degree.degreeId}>{degree.shortForm}</div>
                )}
              </React.Fragment>
            )
          })
        ) : (
          <div>
            {degreeShortFormWithStreams?.length > 0  && degreeShortFormWithStreams.split('\n').map((line, index) => (
              <div key={index+'degree'} className="degree-line">
                {line}
              </div>
            ))}
          </div>
        )}
        - {formatYears(data?.yearOfPassing)}
      </EventData4>
    )
  }
  const formatYears = years => {
    if (typeof years === 'string') {
      return years.replace(/(\d{4})(?=\d)/g, '$1,')
    }
    if (Array.isArray(years)) {
      return years.join(', ')
    }
    return years
  }
  const degreeShortFormWithStreams = degreeDataList?.length > 0 && degreeDataList.flatMap(degree => {
    if(degree.streams.length > 0)
    {
      return degree.streams.flatMap(stream => {
        if (stream.specialisations.length > 0) {
          return stream.specialisations.map(spec => {
            return `${degree.shortForm} - ${stream.name} (${spec})`
          })
        } else if (stream.name) {
          return [`${degree.shortForm} - ${stream.name}`]
        } else {
          return [`${degree.shortForm}`]
        }
      })
    }
    else {
      return [`${degree.shortForm}`]
    }
    })
    .join('\n')
  return (

        <EventStatusCard
          // styleBasedObj={categoryBasedObj}
          borderColor={categoryStyle.borderColor}
          backgroundColor={categoryStyle.backgroundColor}
          color={categoryStyle.textColor}
          width="90%"
          mTop={'5%'}
          mBottom={'5%'}
          padding={'10px 10px 40px 20px'}
        >
          <StyledDivision>
            <EventSection>
              <EventName>{data?.title ?? ''}
              <Category>&nbsp;
  ({data?.category ? typeLabels[data?.category] : ''})
</Category>
              </EventName>
              {/* <Category>({data?.category})</Category> */}
            

            </EventSection>
            <Row style={{ paddingBottom: '10px' }}>
              <Col span={15} >
                {/* <EventRegistration  borderColor={categoryStyle.borderColor}
          backgroundColor={categoryStyle.backgroundColor}
          color={categoryStyle.textColor}>
                  <EventRegistrationText weight={700}>
                    Registration date & time
                  </EventRegistrationText>
                  <EventRegistrationText weight={400}>
                    {moment(data?.registerStartDate).format('D / MM / YYYY') +
                      (data?.registerEndTime
                        ? ' at ' + data.registerEndTime
                        : '')}
                  </EventRegistrationText>
                </EventRegistration> */}
                {data?.registerStartDate && (
                  <EventRegistration
                    borderColor={categoryStyle.borderColor}
                    backgroundColor={categoryStyle.backgroundColor}
                    color={categoryStyle.textColor}
                  >
                    <EventRegistrationText weight={700}>
                      Registration date & time
                    </EventRegistrationText>
                    <EventRegistrationText weight={400}>
                    {data?.registerStartDate?.split('T')[0] === data?.registerEndDate?.split('T')[0] ? 
                        
                        formatDateTime(data.registerStartDate) :
                        
                      `${formatDateTime(data.registerStartDate)} ${' - '} 
                        ${formatDateTime(data.registerEndDate)}`
                       
                  }
                  {
                     (data?.registerEndTime
                          ? ' at ' + formatTime(data.registerEndTime)
                          : '')
                  }
                    </EventRegistrationText>
                  </EventRegistration>
                )}
              </Col>
              {!joinSeminar && data?.isRegister ? (
                <StyledCol span={8} justify={'end'}  style={{paddingTop: '15px'}}>
                  <Button.Primary
                    text="Register"
                    style={{ height: 36 }}
                    onClick={() => handleRegistrationClick(data)}
                    disabled={new Date(data.registerStartDate) > new Date()}
                  />
                </StyledCol>
              ) : null}
              {joinSeminar ? (
                <StyledCol span={8} justify={'end'} style={{paddingTop: '20px'}}>
                  <RegistrationText>Registration Completed!</RegistrationText>
                </StyledCol>
              ) : null}
            </Row>
            {/* <Row style={{ paddingBottom: '2rem' }}>
              <Col span={12}>
                {data?.startDate &&
                data?.endDate &&
                data?.startTime &&
                data?.endDate ? (
                  <EventRegistration
                    darkBG={true}
                    styleBasedObj={categoryBasedObj}
                  >
                    <EventRegistrationText weight={700}>
                      Event date & time
                    </EventRegistrationText>
                    <EventRegistrationText weight={400}>
                      {data?.startDate
                        ? moment(data?.startDate)?.format('D / MM / YYYY') +
                          ' - '
                        : null}
                      {data?.endDate
                        ? moment(data?.endDate)?.format('D / MM / YYYY')
                        : null}
                    </EventRegistrationText>
                    <EventRegistrationText weight={400}>
                      {data?.startTime ? data?.startTime + ' - ' : null}
                      {data?.endTime ? data?.endTime : null}
                    </EventRegistrationText>
                  </EventRegistration>
                ) : null}
              </Col>
              {joinSeminar ? (
                <StyledCol span={12} justify={'end'}>
                  <Button.Primary text="Join Seminar" onClick={handleClick} />
                </StyledCol>
              ) : null}
            </Row> */}

            <Row style={{ paddingBottom: '15px' }}>
              <Col span={12}>
                <EventLabel>
                  Event date & time
                  <EventDatecard
                    borderColor={categoryStyle.borderColor}
                    backgroundColor={categoryStyle.backgroundColor}
                    color={categoryStyle.textColor}
                    hasTime={true}
                    style={{ marginTop: '2px' }}
                  >
                    <EventData1>
                    {data.startDate?.split('T')[0] === data.endDate?.split('T')[0] ? 
                        
                        formatDateTime(data.startDate) :
                        
                      `${formatDateTime(data.startDate)} ${' - '} 
                        ${formatDateTime(data.endDate)}`
          }
                    </EventData1>

                    {data?.startTime && data?.endTime && hasTime && (
                      <EventData1>
                        {formatTime(data.startTime)} -{' '}
                        {formatTime(data.endTime)}
                      </EventData1>
                    )}
                        {data?.allDayEvent &&
                    (
                      <EventData1>
                        All Day
                      </EventData1>
                    )}
                  </EventDatecard>
                </EventLabel>
              </Col>
              {(joinSeminar || !data?.isRegister) && data?.eventMode != 'OFFLINE' ? (
                <StyledCol span={12} justify={'end'} style={{paddingTop: '30px'}}>
                  <Button.Primary text={`Join `+typeLabels[data?.category]} onClick={handleClick} />
                </StyledCol>
              ) : null}

{data?.eventMode === 'OFFLINE' && data?.location?.[0]?.length > 0 &&(
                <Col span={24} >
                  <PreviewTitle>Event Location</PreviewTitle>
                  <PreviewAnswer>{data?.location}</PreviewAnswer>
                </Col>
              )}
            </Row>

            <StyledRow>
              {data?.isRegister  && data?.registerAmount ? (
                <Col span={24} >
                  <PreviewTitle>Registration Amount</PreviewTitle>
                  <PreviewAnswer>INR {data?.registerAmount}</PreviewAnswer>
                </Col>
              ) : null}
            
              <Col span={24}>
                {/* <PreviewTitle>Event for</PreviewTitle> */}
                <PreviewAnswer>
                 
                  <EventLabel>
                    Event For
                    <div>
                <Container1
                  expanded={expanded}
                  style={{
                    height:
                   isHeight  > 250 &&   !expanded
                      ? '200px'
                      : 'auto',
                  }}
                >
                  <EventData4 ref={contentHeight}>{renderContent()}</EventData4>
                </Container1>

                {
                 isHeight > 250 &&
                  (!expanded ? (
                    <ShowMoreText visible={!expanded} onClick={toggleExpanded}>
                      Show More...
                    </ShowMoreText>
                  ) : (
                    <ShowLessText visible={expanded} onClick={toggleExpanded}>
                      Show Less
                    </ShowLessText>
                  ))
              
                }
              </div>
                  </EventLabel>
                </PreviewAnswer>
              </Col>
              {data?.description ? (
  <Col>
    <PreviewTitle>Event Description</PreviewTitle>
    <PreviewAnswer>
      <div
        style={{
          overflowWrap: 'break-word',
          wordWrap: 'break-word',
          wordBreak: 'break-word',  
          whiteSpace: 'pre-wrap',  
        }}
        dangerouslySetInnerHTML={{
          __html: data.description,
        }}
      />
    </PreviewAnswer>
  </Col>
) : null}

              {data?.pocName ? (
                <Col span={24}>
                  <PreviewTitle>POC Details</PreviewTitle>
                  <PreviewAnswer>
                    {data?.pocName} - {data?.pocNumber}
                  </PreviewAnswer>
                </Col>
              ) : null}
              {data?.speakers?.length > 0 ? (
                <Col span={24}>
                  <PreviewTitle>Speakers/Panellist</PreviewTitle>
                  {data?.speakers?.map((item, index) => {
                    return (
                      <PreviewAnswer
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 10,
                        }}
                        key={index+'Speacker'}
                      >
                        <img src={LinkedIn} alt="linkedIn" />
                        <LinkedInLink href={item.link} target="_blank">
                          {item.name}
                        </LinkedInLink>
                      </PreviewAnswer>
                    )
                  })}
                </Col>
              ) : null}
            </StyledRow>

            <div style={{ marginTop: '10px' }}>
              {data.documents &&
                data.documents.map((doc, key) => (
                  <div key={key+'Doc'}>
                    <Uploaders
                      borderColor={categoryStyle.borderColor}
                      onClick={() => downloadFileLocal(doc)}
                    >
                      <div style={{ marginTop: '4px' }}>
                        {' '}
                        <FileIcon/>
                      </div>
                      {truncateName(doc.name, 6)}
                      <Size>{convertBytesToKB(doc.size)} KB</Size>
                    </Uploaders>
                  </div>
                ))}
            </div>
          </StyledDivision>
        </EventStatusCard>
   
  )
}
export default EventPreviewContent